var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningSolid = function SvgWarningSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.702 2.898c-.692-1.197-2.422-1.197-3.115 0L1.244 19.057C.55 20.254 1.417 21.75 2.8 21.75h18.687c1.385 0 2.25-1.496 1.558-2.693l-9.344-16.16ZM12.98 13.96a.836.836 0 0 1-1.671 0V7.287a.836.836 0 1 1 1.671 0v6.674Zm.28 3.618a1.114 1.114 0 0 1-2.23 0 1.114 1.114 0 0 1 2.23 0Z",
    fill: "#000"
  })));
};
export default SvgWarningSolid;